import type { FaireProductEntity } from "../../entity_types/product";

export const p_yb33ajfppb: FaireProductEntity = {
  token: "p_yb33ajfppb",
  type: "product",
  name: "Fino Repair Shampoo & Hair Mask Set【HOT】",
  brandToken: "b_6yzfk84dca",
  brandName: "Yami",
  imageUrl: "https://cdn.faire.com/fastly/b8a1f224fadfa0aaf95ae9e31d93fd20ea9e10e7cf700df272f8a088c6e88d21.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/5c9e738351e1a7f2aac1e732213d65ea95da770f6a6ba6259986be23bd89e72a.jpeg",
    "https://cdn.faire.com/fastly/cc70ab4ddb57847b2dca7d177ddf53618c325f4b117327bef5581365456abcfe.jpeg",
    "https://cdn.faire.com/fastly/a02e626f91e078032e51319efb89e209684d0ed41c23fce5caf5e8148db83e61.png",
    "https://cdn.faire.com/fastly/c7914effeeb2da04e79c75cd41ee83be094231222c55969df4a5c92f105f5273.png",
    "https://cdn.faire.com/fastly/4211959643880abb855f72765b88d5ee385e192bfa7b67431b7ae384f9a23bf8.png",
    "https://cdn.faire.com/fastly/178f510eb348e345be0a03064d60a9620d2f8606f049b2e2ed068f2605f9d065.png",
    "https://cdn.faire.com/fastly/20015705eb9b240a6fce938fd92891a46fc15726927a5dcbdb7c480fe403bf7a.jpeg",
    "https://cdn.faire.com/fastly/e32d3105c544b97e4b8b5588567d788a717e624f2def1824a386308423d788fc.jpeg",
    "https://cdn.faire.com/fastly/3e5fcf750c78586e05f45d2e49fb241e99b38837e0b48738129b818393d5930c.jpeg",
    "https://cdn.faire.com/fastly/a2468fba31038c6cc529e859854bf51700533cf97f2bf847913b1b365195c51b.jpeg"
  ],
  priceDollars: 17.19,
  description: "Bulk pricing available. Contact us via DM/email for large orders. \n\nFino Repair Shampoo & Hair Mask Set : Shampoo 16.9 fl.oz. + Hair mask 8.1oz. - for Damaged Care Deeply Nourish\n\nBrand: SHISEIDO\n\nProduct Highlights\nMultiple beauty serum ingredients, providing a hair care experience akin to skincare. \n\nLuxurious royal jelly extract deeply moisturizes the hair strands, repairs damaged areas, and provides hydration.\n\nEnriched with hair-firming PCA components, it improves fragility, reduces dryness, and prevents breakage.\n\nRich creamy texture melts into the hair, nourishing deeply for smooth and silky locks with every stroke.",
  tags: [],
  msrpDollars: 34.98,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:55:20.526Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
